import { render, staticRenderFns } from "./requisiteArchiveBottom.vue?vue&type=template&id=415eb1d0"
import script from "./requisiteArchiveBottom.vue?vue&type=script&lang=js"
export * from "./requisiteArchiveBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports